import CpcpayRouter from "app-router/cpcpay/cpcpay-router";

export default CpcpayRouter
